<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="480"
    style="z-index: 6"
  >
    <v-form ref="addCommForm" @submit.prevent="submit">
      <v-card class="add-comm-card">
        <v-card-title class="add-comm-header">
          <span class="add-comm-title">Dodaj kontakt</span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="close">
            <v-icon color="#94A3B8">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6 pb-2">
          <v-select
            outlined
            dense
            hide-details
            label="Tip"
            v-model="selectedCommType"
            :items="availableComms"
            item-text="text"
            item-value="id"
            return-object
            :rules="[rules.req]"
            class="add-comm-field mb-4"
          />
          <v-text-field
            outlined
            dense
            hide-details
            label="Vrijednost"
            v-model="value"
            :rules="[rules.req]"
            class="add-comm-field mb-4"
          />
          <v-select
            v-if="selectedCommType !== undefined"
            outlined
            dense
            hide-details
            multiple
            label="Koristi se za"
            v-model="selectedUsage"
            :items="selectedCommType.available_usage"
            item-text="text"
            item-value="id"
            :rules="[rules.req]"
            class="add-comm-field"
          />
        </v-card-text>

        <v-card-actions class="px-6 pb-5 pt-4 d-flex justify-end">
          <v-btn text class="add-comm-cancel-btn" @click="close">Odustani</v-btn>
          <v-btn elevation="0" class="add-comm-save-btn" :loading="submitting" :disabled="submitting" type="submit">Dodaj</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { df } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import rules from '@/plugins/rules'
import state from '@/state'
// import clone from '@/plugins/utils'

export default {
  components: { },
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data: () => ({
    visible: false,
    location: undefined,
    submitting: false,
    type: undefined,
    selectedCommType: undefined,
    selectedUsage: [],
    value: undefined,
    rules: {
      req: rules.req(),
      eq: rules.eq
    },
    availableComms: [],
    listeners: []
  }),
  mounted () {

  },
  methods: {
    open () {
      this.getCommTypes()
      this.visible = true
      this.submitting = false
      this.selectedCommType = undefined
    },
    getCommTypes () {
      const listener = df.doc('project_constants/communications').onSnapshot(doc => {
        this.availableComms = doc.data().types
      })
      this.listeners.push(listener)
    },
    close () {
      this.resetInputs()
    },
    resetInputs () {
      this.type = undefined
      this.visible = false
      this.location = undefined
    },
    async submit () {
      const tblId = uuidv4()
      const docRef = df.doc(`company_communications/${state.getCurrentCompany().id}/communications/${tblId}`)

      if (!this.$refs.addCommForm.validate()) {
        return
      }

      var commParams = {
        id: tblId,
        type: this.selectedCommType.id,
        usage: this.selectedUsage,
        value: this.value
      }

      try {
        await docRef.set(
          commParams
        )
      } catch (err) {
        console.error('Error saving communication: ', err)
      }

      this.resetInputs()
    }
  }

}
</script>
<style scoped>
.add-comm-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  overflow: hidden;
}

.add-comm-header {
  padding: 20px 24px 16px !important;
  border-bottom: 1px solid #EEF2F5;
}

.add-comm-title {
  font-size: 16px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.2px;
}

.add-comm-field.v-text-field--outlined >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}

.add-comm-field.v-text-field--outlined:hover >>> fieldset {
  border-color: #B0BEC5 !important;
}

.add-comm-field.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.add-comm-field >>> .v-input__slot {
  background: #F8FAFC !important;
}

.add-comm-cancel-btn {
  color: #64748B !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  margin-right: 8px;
}

.add-comm-save-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  height: 38px !important;
  padding: 0 20px !important;
}

.add-comm-save-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
}
</style>
